import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#F0F4F8] to-white">
      <Navbar />
      
      <main className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#1E5A8E] mb-8">
            Privacy Policy
          </h1>
          
          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
            <div className="prose prose-lg max-w-none">

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  1. Information We Collect
                </h2>
                <p className="text-[#4A5568] leading-relaxed mb-4">
                  RECOVER collects information that you provide directly to us when you:
                </p>
                <ul className="list-disc pl-6 text-[#4A5568] space-y-2">
                  <li>Create an account</li>
                  <li>Use our mental health assessment tools</li>
                  <li>Track your mood and wellness activities</li>
                  <li>Interact with our content and features</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  2. How We Use Your Information
                </h2>
                <p className="text-[#4A5568] leading-relaxed mb-4">
                  We use the information we collect to:
                </p>
                <ul className="list-disc pl-6 text-[#4A5568] space-y-2">
                  <li>Provide, maintain, and improve our services</li>
                  <li>Personalize your experience</li>
                  <li>Send you technical notices and support messages</li>
                  <li>Monitor and analyze trends and usage</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  3. Information Sharing
                </h2>
                <p className="text-[#4A5568] leading-relaxed">
                  We do not share your personal information with third parties except as described in this privacy policy. We may share information in the following circumstances:
                </p>
                <ul className="list-disc pl-6 text-[#4A5568] space-y-2 mt-4">
                  <li>With your consent</li>
                  <li>To comply with legal obligations</li>
                  <li>To protect rights and safety</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  4. Data Security
                </h2>
                <p className="text-[#4A5568] leading-relaxed">
                  We take reasonable measures to help protect your personal information from loss, theft, misuse, unauthorized access, disclosure, alteration, and destruction.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  5. Your Rights
                </h2>
                <p className="text-[#4A5568] leading-relaxed mb-4">
                  You have the right to:
                </p>
                <ul className="list-disc pl-6 text-[#4A5568] space-y-2">
                  <li>Access your personal information</li>
                  <li>Correct inaccurate data</li>
                  <li>Request deletion of your data</li>
                  <li>Object to processing of your data</li>
                  <li>Export your data</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  6. Children's Privacy
                </h2>
                <p className="text-[#4A5568] leading-relaxed">
                  RECOVER is not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  7. Changes to This Policy
                </h2>
                <p className="text-[#4A5568] leading-relaxed">
                  We may update this privacy policy from time to time. We will notify you of any changes by posting the new privacy policy on this page and updating the "Last updated" date.
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-[#2F7FB7] mb-4">
                  8. Contact Us
                </h2>
                <p className="text-[#4A5568] leading-relaxed">
                  If you have any questions about this Privacy Policy, please contact us through the app or visit our support page.
                </p>
              </section>
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-[#6B7280] text-sm">
              Last updated: January 2025
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
